import { Button, Input, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextareaAutosize } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import UserLoader from "src/Dashboard/UserLoader";
import { AddUpdateCourseQuestionsAsync, GetCourseQuestionAsync } from "src/handler/coursehandler";
import { dashboard } from "src/handler/LoginAndSingupHandler";

const CourseQuestion = () => {
    type Course = {
        courseId: number,
        courseName: string,
        packageId: number,
        courseDescription: string,
        coursePrice: number
    }
    const [courses, setCourses] = useState<Course[]>([
        {
            courseId: 0,
            courseName: "",
            packageId: 0,
            courseDescription: "",
            coursePrice: 0
        }
    ]);
    const [courseQuestions, setCourseQuestions] = useState([{
        "courseTestId": 0,
        "courseId": 0,
        "courseQuestion": "",
        "option1": "",
        "option2": "",
        "option3": "",
        "option4": "",
        "answerOption": 0
    }])
    const [selectedCourse, setSelectedCourse] = useState(1);
    const [updateCourseTest, setUpdateCourseTest] = useState({
        "courseId": selectedCourse,
        "courseQuestion": "",
        "option1": "",
        "option2": "",
        "option3": "",
        "option4": "",
        "answerOption": 1,
        "courseTestId": 0
    })
    const [addMcqSelect, setAddMcqSelect] = useState(false);
    const getCourses = async () => {
        var response = await dashboard(2);
        if (response.statusCode === 200) {
            setCourses(response.data.dashboard.courses);
        }
    }
    const getCoursesQuestion = async (courseId: number) => {
        var response = await GetCourseQuestionAsync(courseId);
        if (response.statusCode === 200) {
            setCourseQuestions(response.data.courseTest);
        }
    }
    const GetCourseQuestions = (courseId: number) => {
        setLoader(true);
        setSelectedCourse(courseId);
        getCoursesQuestion(courseId);
        setLoader(false);
    }
    const [loader, setLoader] = useState(false);
    const handelOnChange = (name: string, e: any) => {
        const value = e.target.value;
        setUpdateCourseTest((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const AddMCQQuestion = async (event: any) => {
        event.preventDefault();
        setLoader(true);
        setUpdateCourseTest((prevData) => ({
            ...prevData,
            ["courseId"]: selectedCourse
        }));
        var response = await AddUpdateCourseQuestionsAsync(updateCourseTest);
        if (response.statusCode === 200) {
            setCourseQuestions(response.data.courseTest);
        }
        setAddMcqSelect(false);
        setLoader(false);
    }
    const [addMCQ, setAddMCQ] = useState(false);
    var runOnce = useRef(false);
    useEffect(() => {
        if (runOnce.current === false) {
            getCourses();
            runOnce.current = true;
        }
    }, [runOnce])
    return (
        <>
            {
                loader ?
                    <><UserLoader /></>
                    :
                    <>
                        <section className='headerBackground' style={{ padding: "10px" }}>
                            <div style={{ display: "flex", justifyContent: "center", padding: "10px 0" }}>
                                <select
                                    value={selectedCourse}
                                    id="packageDropdown"
                                    style={{ padding: "10px", border: "1px solid #343434", borderRadius: "10px", color: "black", fontWeight: "bold",background:"white" }}
                                    onChange={(e) => { GetCourseQuestions(parseInt(e.target.value)); handelOnChange("courseId", e) }}
                                >
                                    <option value="" disabled>
                                        Select Course
                                    </option>
                                    {
                                        courses.map((courses) => (
                                            <option key={courses.courseId} value={courses.courseId}>
                                                {courses.courseId}. {courses.courseName}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div style={{ display: "flex", justifyContent: "right", padding: "10px 0" }}>
                                <Button onClick={() => {
                                    setAddMcqSelect(true); setUpdateCourseTest({
                                        "courseId": selectedCourse,
                                        "courseQuestion": "",
                                        "option1": "",
                                        "option2": "",
                                        "option3": "",
                                        "option4": "",
                                        "answerOption": 1,
                                        "courseTestId": 0
                                    }); setAddMCQ(true);
                                }}
                                    style={{
                                        backgroundColor: "#4CAF50",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 20px",
                                        fontSize: "16px",
                                        cursor: "pointer",
                                        borderRadius: "5px",
                                    }}
                                >
                                    Add MCQ
                                </Button>
                            </div>
                            <div style={{ background: "white" }}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">Sr.No</TableCell>
                                                <TableCell align="center">Question</TableCell>
                                                <TableCell align="center">Option 1</TableCell>
                                                <TableCell align="center">Option 2</TableCell>
                                                <TableCell align="center">Option 3</TableCell>
                                                <TableCell align="center">Option 4</TableCell>
                                                <TableCell align="center">Answer Option</TableCell>
                                                <TableCell align="center">Action</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                courseQuestions.map((data, index) => (
                                                    <TableRow>
                                                        <TableCell align="center">{index + 1}</TableCell>
                                                        <TableCell align="center">{data.courseQuestion}</TableCell>
                                                        <TableCell align="center">{data.option1}</TableCell>
                                                        <TableCell align="center">{data.option2}</TableCell>
                                                        <TableCell align="center">{data.option3}</TableCell>
                                                        <TableCell align="center">{data.option4}</TableCell>
                                                        <TableCell align="center">{data.answerOption}</TableCell>
                                                        <TableCell align="center">
                                                            <Button onClick={() => {
                                                                setAddMcqSelect(true); setUpdateCourseTest({
                                                                    "courseId": data.courseId,
                                                                    "courseQuestion": data.courseQuestion,
                                                                    "option1": data.option1,
                                                                    "option2": data.option2,
                                                                    "option3": data.option3,
                                                                    "option4": data.option4,
                                                                    "answerOption": data.answerOption,
                                                                    "courseTestId": data.courseTestId
                                                                }); setAddMCQ(false)
                                                            }}
                                                                style={{
                                                                    backgroundColor: "#4CAF50",
                                                                    color: "white",
                                                                    border: "none",
                                                                    padding: "10px 20px",
                                                                    fontSize: "16px",
                                                                    cursor: "pointer",
                                                                    borderRadius: "5px",
                                                                }}
                                                            >
                                                                Edit
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </section>
                        {
                            addMcqSelect && (
                                <>
                                    <section style={{ height: "100%", width: "100%", position: "fixed", top: "0", zIndex: "1000", padding: "10%", background: "rgba(0, 0, 0, .8)" }}>
                                        <div style={{ position: "fixed", top: "2%", right: "2%" }}>
                                            <Button
                                                onClick={() => { setAddMcqSelect(false) }}
                                                style={{
                                                    backgroundColor: "#D52C2C",
                                                    color: "white",
                                                    border: "none",
                                                    padding: "10px 20px",
                                                    fontSize: "16px",
                                                    cursor: "pointer"
                                                }}>X</Button>
                                        </div>
                                        <div style={{ background: "white", height: "100%", padding: "10px" }}>
                                            <form onSubmit={AddMCQQuestion}>
                                                <TableContainer>
                                                    <Table>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center">CourseId</TableCell>
                                                                <TableCell align="center">:</TableCell>
                                                                <TableCell align="center">{selectedCourse}</TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="center">Question</TableCell>
                                                                <TableCell align="center">:</TableCell>
                                                                <TableCell align="center"><TextareaAutosize style={{ width: "500px", height: "80px" }} value={updateCourseTest.courseQuestion} onChange={(e) => { handelOnChange("courseQuestion", e) }} placeholder='Course Question' required /></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="center">Option 1</TableCell>
                                                                <TableCell align="center">:</TableCell>
                                                                <TableCell align="center"><Input placeholder='Course Option 1' value={updateCourseTest.option1} onChange={(e) => { handelOnChange("option1", e) }} required /></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="center">Option 2</TableCell>
                                                                <TableCell align="center">:</TableCell>
                                                                <TableCell align="center"><Input placeholder='Course Option 2' value={updateCourseTest.option2} onChange={(e) => { handelOnChange("option2", e) }} required /></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="center">Option 3</TableCell>
                                                                <TableCell align="center">:</TableCell>
                                                                <TableCell align="center"><Input placeholder='Course Option 3' value={updateCourseTest.option3} onChange={(e) => { handelOnChange("option3", e) }} required /></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="center">Option 4</TableCell>
                                                                <TableCell align="center">:</TableCell>
                                                                <TableCell align="center"><Input placeholder='Course Option 4' value={updateCourseTest.option4} onChange={(e) => { handelOnChange("option4", e) }} required /></TableCell>
                                                            </TableRow>
                                                            <TableRow>
                                                                <TableCell align="center">Answer Option</TableCell>
                                                                <TableCell align="center">:</TableCell>
                                                                <TableCell align="center">
                                                                    <select value={updateCourseTest.answerOption} onChange={(e) => { handelOnChange("answerOption", e) }} style={{ padding: "5px", border: "2px solid black" }} required >
                                                                        <option key={1} value={1}>Option 1</option>
                                                                        <option key={2} value={2}>Option 2</option>
                                                                        <option key={3} value={3}>Option 3</option>
                                                                        <option key={4} value={4}>Option 4</option>
                                                                    </select>
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                    </Table>
                                                </TableContainer>
                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                    <Button
                                                        type="submit"
                                                        style={{
                                                            backgroundColor: "#4CAF50",
                                                            color: "white",
                                                            border: "none",
                                                            padding: "10px 20px",
                                                            fontSize: "16px",
                                                            cursor: "pointer",
                                                            borderRadius: "5px",
                                                        }}
                                                    >
                                                        {
                                                            addMCQ ? "Add MCQ" : "Edit MCQ"
                                                        }
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>
                                    </section>
                                </>
                            )
                        }
                    </>
            }
        </>
    );
};

export default CourseQuestion;
